import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

import {DataFrameTableMode} from '../DataFrameTableConstants';

interface UseDataFrameTableModeOutput {
  /** @default DataFrameTableMode.TEXT unless `defaultMode` is passed to `useDataFrameTableMode`.  */
  tableMode: DataFrameTableMode;
  setTableMode: (newTableMode: DataFrameTableMode) => void;
}

const dataFrameTableModeState = makeUseGlobalClientState<DataFrameTableMode | null>(null);

export default function useDataFrameTableMode(
  clientStateId: string,
  defaultMode: DataFrameTableMode = DataFrameTableMode.TEXT
): UseDataFrameTableModeOutput {
  const [tableMode, setTableMode] = dataFrameTableModeState.useGlobalClientState(clientStateId);

  return {
    tableMode: tableMode ?? defaultMode,
    setTableMode,
  };
}
